import { ArrowUpRight, Globe, MapPin, Wrench, Rocket } from 'lucide-react'
import Reveal from './Reveal'

const SERVICES = [
  {
    icon: Globe,
    title: 'Business website design',
    price: 'From $1,500',
    desc: 'A fast, mobile-friendly site that explains what you do and turns local visitors into calls and bookings.',
    tags: ['5 to 12 pages', 'On-page SEO + schema', 'Booking & contact forms', 'Live in 5 to 7 days'],
  },
  {
    icon: MapPin,
    title: 'Google Business Profile management',
    price: 'From $299/mo',
    desc: 'The first thing nearby customers see. I clean it up, keep it active, and make sure you look legit when they search.',
    tags: ['Profile setup & clean-up', 'Weekly Google Posts', 'Review monitoring', 'Monthly reporting'],
  },
  {
    icon: Wrench,
    title: 'Website maintenance',
    price: 'From $199/mo',
    desc: 'Updates, hosting, and small changes handled, so your site never goes stale and you never chase a freelancer.',
    tags: ['Hosting & uptime', 'Content updates', 'Security checks', 'Monthly report'],
  },
  {
    icon: Rocket,
    title: 'Business launch package',
    price: 'From $4,000',
    desc: 'Starting fresh or rebranding? Website, Google Business Profile, directory listings, and launch content, done together.',
    tags: ['Everything in Pro', 'GBP setup', 'Directory submissions', '5 launch blog posts'],
  },
]

const scrollToContact = () => document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' })

const Services = () => {
  return (
    <section id="services" className="relative py-24 lg:py-32">
      <div className="mx-auto max-w-container px-5 lg:px-8">
        <div className="grid gap-10 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16">
          {/* Sticky header */}
          <div className="lg:sticky lg:top-28 lg:self-start">
            <Reveal>
              <p className="eyebrow">What I do</p>
              <h2 className="font-display mt-4 text-4xl font-extrabold leading-[1.05] tracking-tight text-ink sm:text-5xl">
                Four ways to get your Melbourne business found.
              </h2>
              <p className="mt-6 max-w-md text-lg text-ink-soft">
                Pick one or stack a few. Everything is scoped and priced upfront, so you always
                know what you are paying for before we start.
              </p>
              <button onClick={scrollToContact} className="btn btn-primary mt-8">
                Tell me what you need
                <ArrowUpRight className="h-4 w-4" />
              </button>
            </Reveal>
          </div>

          {/* Index list */}
          <div className="divide-hair border-t border-[var(--line)]">
            {SERVICES.map((s, i) => (
              <Reveal key={s.title} delay={i * 0.05}>
                <button
                  onClick={scrollToContact}
                  className="group grid w-full grid-cols-[auto_1fr] gap-x-5 gap-y-4 py-8 text-left transition-colors sm:grid-cols-[auto_1fr_auto]"
                >
                  <span className="grid h-12 w-12 place-items-center rounded-2xl bg-ink text-cream transition-transform duration-300 group-hover:-translate-y-1">
                    <s.icon className="h-5 w-5" strokeWidth={1.75} />
                  </span>

                  <div className="min-w-0">
                    <div className="flex items-center gap-2">
                      <h3 className="font-display text-xl font-bold text-ink sm:text-2xl">{s.title}</h3>
                      <ArrowUpRight className="h-5 w-5 text-ink-faint opacity-0 transition-all duration-300 group-hover:translate-x-1 group-hover:text-gold group-hover:opacity-100" />
                    </div>
                    <p className="mt-2 max-w-lg text-[0.98rem] text-ink-soft">{s.desc}</p>
                    <div className="mt-4 flex flex-wrap gap-2">
                      {s.tags.map((t) => (
                        <span
                          key={t}
                          className="rounded-full border border-[var(--line)] bg-cream-deep/40 px-3 py-1 text-[0.78rem] font-medium text-ink-soft"
                        >
                          {t}
                        </span>
                      ))}
                    </div>
                  </div>

                  <span className="font-display whitespace-nowrap text-lg font-bold text-gold sm:col-start-3 sm:text-right">
                    {s.price}
                  </span>
                </button>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default Services
